import React from 'react'
import { Main } from './components'

const Roles = () => <Main />

export default Roles
